import { ApiError, ReturnUtil } from 'rsper';
import { twarn } from 'logitool';
import { API, N8N } from '@/config/constant';

interface FetchAPIParams {
  path: string;
  method?: string;
  data?: any;
  baseUrl: string;
  token: string;
}

export async function fetchAPI({
  path,
  method = 'GET',
  data = undefined,
  baseUrl = API.CONTENT.HOST,
  token = API.CONTENT.TOKEN,
}: FetchAPIParams) {
  const headers = {
    Authorization: `Token ${token}`,
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  const options: RequestInit = {
    method,
    headers,
    cache: 'no-store',
    credentials: 'include',
  };

  let urlPath = path;

  if ((method.toUpperCase() === 'GET' || method.toUpperCase() === 'DELETE') && data) {
    const queryParams = new URLSearchParams(data).toString();
    urlPath += (urlPath.includes('?') ? '&' : '?') + queryParams;
  }

  if (data && method.toUpperCase() != 'GET') {
    options.body = JSON.stringify(data);
  }

  try {
    const response: Response = await fetch(`${baseUrl}${urlPath}`, options);

    if (!response.ok) throw new ApiError(response);

    return response.json();
  } catch (error: any) {
    if (error instanceof ApiError) {
      const errorJson = await error.response.json();
      twarn(error, `api-server.705448`);
      throw ReturnUtil.error(`Failed: ${error.message}`, errorJson);
    } else {
      throw error;
    }
  }
}

export function getContentData(path: string): Promise<any>;
export function getContentData(path: string, data: Record<string, any>): Promise<any>;

export function getContentData(path: string, data?: Record<string, any>) {
  return data ? fetchAPI({
    path,
    method: 'GET',
    data,
    baseUrl: API.CONTENT.HOST,
    token: API.CONTENT.TOKEN
  }) : fetchAPI({
    path,
    baseUrl: API.CONTENT.HOST,
    token: API.CONTENT.TOKEN
  });
}

export async function genContentData(path: string, data: any) {
  return fetchAPI({
    method: 'POST',
    path,
    data,
    baseUrl: API.CONTENT.HOST,
    token: API.CONTENT.TOKEN
  });
}

export async function updateContentData(path: string, data: any) {
  return fetchAPI({
    method: 'PUT',
    path,
    data,
    baseUrl: API.CONTENT.HOST,
    token: API.CONTENT.TOKEN
  });
}

export function deleteContentData(path: string): Promise<any>;
export function deleteContentData(path: string, data: Record<string, any>): Promise<any>;

export function deleteContentData(path: string, data?: Record<string, any>) {
  return fetchAPI({
    path,
    method: 'DELETE',
    data,
    baseUrl: API.CONTENT.HOST,
    token: API.CONTENT.TOKEN
  })
}

export function getPenpotData(path: string) {
  return fetchAPI({
    path,
    method: 'GET',
    baseUrl: API.PENPOT.HOST,
    token: API.CONTENT.TOKEN
  });
}

export function getN8NData(path: string): Promise<any>;
export function getN8NData(path: string, data: Record<string, any>): Promise<any>;

export function getN8NData(path: string, data?: Record<string, any>) {
  return data ? fetchAPI({
    path,
    method: 'GET',
    data,
    baseUrl: N8N.HOST,
    token: N8N.TOKEN,
  }) : fetchAPI({
    path,
    baseUrl: N8N.HOST,
    token: N8N.TOKEN,
  });
}

export async function genN8NData(path: string, data: any) {
  return fetchAPI({
    method: 'POST',
    path,
    data,
    baseUrl: N8N.HOST,
    token: N8N.TOKEN
  });
}

export async function updateN8NData(path: string, data: any) {
  return fetchAPI({
    method: 'PUT',
    path,
    data,
    baseUrl: N8N.HOST,
    token: N8N.TOKEN
  });
}

export function deleteN8NData(path: string): Promise<any>;
export function deleteN8NData(path: string, data: Record<string, any>): Promise<any>;

export function deleteN8NData(path: string, data?: Record<string, any>) {
  return fetchAPI({
    path,
    method: 'DELETE',
    data,
    baseUrl: N8N.HOST,
    token: N8N.TOKEN
  })
}
